import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, Heart, User } from 'lucide-react';

export default function MobileNav() {
    const location = useLocation();
    const navigate = useNavigate();

    const handleProfileClick = () => {
        const user = localStorage.getItem('PK_user');
        if (!user) {
            const modal = new window.bootstrap.Modal(document.getElementById('loginModal'));
            modal.show();
        } else {
            navigate('/profile');
        }
    };

    const navItems = [
        { path: '/', label: 'Home', icon: Home, onClick: () => navigate('/') },
        { path: '/search', label: 'Search', icon: Search, onClick: () => navigate('/search') },
        { path: '/favorites', label: 'Favorites', icon: Heart, onClick: () => navigate('/favorites') },
        { path: '/profile', label: 'Profile', icon: User, onClick: handleProfileClick },
    ];

    return (
        <div className="mobile-nav">
            {navItems.map(({ path, label, icon: Icon, onClick }) => (
                <button
                    key={path}
                    className={`nav-item ${location.pathname === path ? 'active' : ''}`}
                    onClick={onClick}
                >
                    <Icon size={24} />
                    <span>{label}</span>
                </button>
            ))}
        </div>
    );
}
